import {setConversationTeamStatus} from '../../../helpers/models/conversationHelpers';
import {ConversationTeamStatusesEnum} from '../../../models/api/conversationCommonTypes';
import {updateConversationsAction} from './updateConversationsActions';

export function setConversationsTeamStatusAction(
  conversationIds: ReadonlyArray<number>,
  newTeamStatus: ConversationTeamStatusesEnum,
) {
  return updateConversationsAction(
    conversationIds,
    {teamStatus: newTeamStatus},
    setConversationTeamStatus(newTeamStatus),
  );
}
